import * as actions from './actions'; // Asegúrate de que la ruta sea correcta

import api from "../utils/api";

export const monitoreoCreateNewcard = (new_registro) => {
    return async function (dispatch) {
      try {
        const newCard = await api.fetchMonitoreoNuevoRegistro(new_registro);
        dispatch(actions.monitoreoCreateNewCardAction(newCard));
      } catch (error) {
        console.log(error);
      }
    };
  };
  
 export  const monitoreoCreateNewPublication = (newPublication) => {
    return async function (dispatch) {
      try {
        const newPublicationId = await api.postNuevaDesinformacionManual(
          newPublication
        );
        dispatch(actions.postMonitoreoAsociadoStatusSuccess());
      } catch (error) {
        dispatch(actions.showStatusRegistroManualError());
      }
    };
  };
  
  export const monitoreoCreateNewPublicationTwitter = (newPublicationTwitter) => {
    return async function (dispatch) {
      try {
        const newPublicationId = await api.postNuevaDesinformacionManualTwitter(
          newPublicationTwitter
        );
        dispatch(actions.postMonitoreoAsociadoStatusSuccess());
      } catch (error) {
        dispatch(actions.showStatusRegistroManualError());
      }
    };
  };

  
  export const getCardsRequestDefault = (arg) => {
    return async (dispatch) => {
      try {
        dispatch(actions.loadingAction()); // Indica que se está cargando
        const cards = await api.fetchDataCardsDefault(arg); // Llama a la API para obtener las cartas
        console.log(" // Llama a la API para obtener las cartas", cards);
        
        dispatch(actions.fetchCardsSuccessAction(cards)); // Despacha la acción para guardar las cartas en el estado
        dispatch(actions.finishedLoadingAction()); // Finaliza la carga
      } catch (error) {
        console.error("Error fetching cards:", error);
        dispatch(actions.finishedLoadingAction()); // Finaliza la carga incluso si hay un error
        // Aquí podrías despachar una acción de error si es necesario
      }
    };
  };
  
  export const getFilterRequest = (arg) => {
    return async (dispatch) => {
      try {
        dispatch(actions.loadingAction()); // Indica que se está cargando
        const filter = await api.fetchDataFilter(); // Llama a la API para obtener los filtros
        dispatch(actions.fetchFilterSuccessAction(filter)); // Despacha la acción para guardar los filtros en el estado
  
        const cards = await api.fetchDataCardsDefault(arg); // Llama nuevamente a la API para obtener las cartas
        dispatch(actions.fetchCardsSuccessAction(cards)); // Despacha la acción para guardar las cartas en el estado
        dispatch(actions.finishedLoadingAction()); // Finaliza la carga
      } catch (error) {
        console.error("Error fetching filter:", error);
        dispatch(actions.finishedLoadingAction()); // Finaliza la carga incluso si hay un error
        // Aquí podrías despachar una acción de error si es necesario
      }
    };
  };

 
  
  export const getLogin = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchUserLogin(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  
  export const getCleanErrorDesgrabador = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchDesgrabadorErrorClean());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getToken = (token) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchToken(token));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
 };
  
 export const getUrl = (url) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchUrl(url));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getDesgrabador = (video_url, lang) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabador(video_url, lang);
        dispatch(getDesgrabadorHistorial());
        if (data) {
          dispatch(actions.fetchDesgrabador(data));
          if (lang === "es" && data.subtitles && data.subtitles.length > 0) {
            const sentences = data.subtitles.map((el) => el.text);
  
            if (sentences && sentences.length > 0) {
              await dispatch(getTextosDesgrabador(sentences));
              console.log("getTextosDesgrabador llamado con éxito.");
            } else {
              console.log("No hay sentences válidas para getTextosDesgrabador.");
            }
          }
        } else {
          console.log("No hay datos de desgrabador en la respuesta.");
        }
      } catch (error) {
        console.error("Error en getDesgrabador:", error);
        dispatch(actions.fetchDesgrabadorError(error));
      }
    };
  };
  
  export const getDesgrabadorFile = (file) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabadorFile(file);
        dispatch(getDesgrabadorHistorialFichero());
      } catch (error) {
        if (error.response?.status === 400) {
          const errorMessage = error.response.data.error;
          dispatch(actions.fetchDesgrabadorFicheroError(errorMessage));
        } else {
          dispatch(actions.fetchDesgrabadorFicheroError("Error al procesar el archivo"));
        }
      }
    };
  };

  export const getTextos = (text) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchTextos(text);
        dispatch(actions.fetchTextos(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getTextosDesgrabador = (sentences) => {
    console.log("sentences111", sentences);
    return async function (dispatch) {
      try {
        const data = await api.fetchTextosDesgrabador(sentences);
        dispatch(actions.setLabelDesgrabador(data));
      } catch (error) {
        dispatch(actions.fetchDesgrabadorError(error));
      }
    };
  };
  
  export const getTextosDesgrabadorHistorial = (sentences) => {
    console.log("hola");
    
    return async function (dispatch) {
      try {
        const data = await api.fetchTextosDesgrabador(sentences);
        dispatch(actions.setLabelDesgrabadorHistorial(data));
      } catch (error) {
        dispatch(actions.fetchDesgrabadorError(error));
      }
    };
  };
  
  export const getDays = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchDays(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getQuery = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchQuery(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getQueryName = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchQueryName(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getPage = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchPage(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMedia = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchMedia(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getOrder = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchOrder(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getCategory = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchCategory(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getCardStatus = (id, ic) => {
    return async function (dispatch) {
      try {
        const value = await api.fetchDataCardStatus(id, ic);
        dispatch(actions.getCardsRequestDefault());
        dispatch(actions.fetchCardStatus());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getFilterFlag = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchFilterFlag());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getTrello = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchTrello());
        const value = await api.fetchTrello(id);
        dispatch(actions.setLabelTrello(id));
        dispatch(actions.fetchTrelloSuccessAction());
      } catch (error) {
        dispatch(actions.fetchTrelloError(error));
      }
    };
  };
  
  export const getQueryTitle = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchQueryTitle(status));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getItemsMenu = () => {
    return async function (dispatch) {
      try {
        const items = await api.fetchDataModulos();
  
        dispatch(actions.fetchItems(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMessagesUpdate = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data1 = await api.fetchAppministradorUpdate();
        dispatch(actions.finishedLoadingAction());
  
        dispatch(actions.loadingAction());
        const data2 = await api.postAppministrador(data1);
        // TODO: implement this
        // dispatch(actions.postMessagesAppministradorRequestValidation(data2));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const postResolveMessage = (arg) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data1 = await api.postResolveMessage(arg);
        dispatch(actions.finishedLoadingAction());
  
        dispatch(actions.loadingAction());
        const data2 = await api.fetchAppministrador();
        dispatch(actions.fetchMessagesAppministradorSuccessAction(data2));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMessagesFilter = (items) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchMessagesFilter(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMonitoreoRequest = (filtros) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchMonitoreoRequestAction());
        const items = await api.fetchDataMonitoreo(filtros);
        dispatch(actions.fetchMonitoreoSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const getUserData = () => {
    return async function (dispatch) {
      try {
        const items = await api.fetchDataUser();
        dispatch(actions.fetchUser(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getDataCard = (id) => {
    return async function (dispatch) {
      try {
        if (!id) {
          dispatch(actions.monitoreoCardSelected({}));
        } else {
          const items = await api.getMonitoreoCard(id);
          dispatch(actions.monitoreoCardSelected(items));
        }
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getNewDataUser = (id, data) => {
    return async function (dispatch) {
      try {
        const pass = await api.fetchNewDataUser(id, data);
        dispatch(actions.fetchNewDataUser(pass));
      } catch (error) {
        dispatch(actions.errorNewData(true));
      }
    };
  };
  
  export const getListData = () => {
    return async function (dispatch) {
      try {
        const data = await api.fetchListData();
        dispatch(actions.fetchListData(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getListInvitation = (newMedio) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchListInvitation(newMedio);
        dispatch(actions.fetchListInvitation(data));
        const reloadData = await api.fetchListData();
        dispatch(actions.fetchListData(reloadData));
      } catch (error) {
        dispatch(actions.errorInvitation(true));
      }
    };
  };
  
  export const getNewPass = (items) => {
    return async function (dispatch) {
      try {
        const pass = await api.fetchDataResetPassword(items);
        dispatch(actions.fetchNewPass(pass));
        localStorage.removeItem("token");
        localStorage.setItem("token", pass);
      } catch (error) {
        dispatch(actions.errorNewPassword(true));
      }
    };
  };
  
  export const getListInvitationDelete = (id) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchListInvitationDelete(id);
        dispatch(actions.fetchListInvitationDelete(data));
  
        const reloadData = await api.fetchListData();
        dispatch(actions.fetchListData(reloadData));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getPedidosDelete = (arg) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchPedidoDelete(arg);
        dispatch(actions.fetchListPedidoDelete(data));
  
        const data1 = await api.fetchHomePedidos(arg);
        dispatch(actions.fetchHomePedidosSuccessAction(data1));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMediosUserQsch = () => {
    return async function (dispatch) {
      try {
        const data = await api.fetchMediosUserQsch();
        dispatch(actions.fetchMediosUserQsch(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getNewUserActive = (id, items) => {
    return async function (dispatch) {
      try {
        // const data = await api.fetchNewUserActive(id, items);
        // dispatch(actions.fetchNewUserActive(data));
      } catch (error) {
        // dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getCodeNewUser = (userData) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchCodeNewUser(userData);
        dispatch(actions.fetchCodeNewUser(data));
        localStorage.removeItem("token");
        localStorage.setItem("token", data.token);
      } catch (error) {
        dispatch(actions.fetchCodeNewUserFail(error));
      }
    };
  };
  
  export const getCodeNewUserFail = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchCodeNewUserFail());
      } catch (error) {
        dispatch(actions.fetchFailureAction());
      }
    };
  };
  
  export const getCodeFail = () => {
    /*   return async function (dispatch) {
      try {
        dispatch(actions.fetchCodeNewUserFail());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    }; */
  };
  
  export const getFirstPass = (newPass) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchFirstPass(newPass);
        dispatch(actions.fetchFirstPass(data));
        localStorage.removeItem("token");
      } catch (error) {
        dispatch(actions.fetchFirstPassFailure());
      }
    };
  };
  
  export  const getResetPassword = (email) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchResetPass(email);
        dispatch(actions.fetchFirstPass(data));
      } catch (error) {
        dispatch(actions.fetchFirstPassFailure());
      }
    };
  };
  
  export  const getResetPasswordComplete = (items) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchResetPasswordComplete(items);
        dispatch(actions.fetchFirstPass(data));
      } catch (error) {
        dispatch(actions.fetchFirstPassFailure());
      }
    };
  };
  
  export const getFileUpload = (items) => {
    return async function (dispatch) {
      try {
        const data = await api.getFileUpload(items);
        dispatch(actions.fetchLFileSuccess(data));
  
        dispatch(actions.loadingAction());
        const redes = await api.fetchRedes();
        dispatch(actions.fetchRedesSuccessAction(redes));
      } catch (error) {
        dispatch(actions.errorFile(true));
      }
    };
  };
  
  export const getRedesRequest = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const redes = await api.fetchRedes();
        dispatch(actions.fetchRedesSuccessAction(redes));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMonitoreoUser = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataUserMonitoreo();
        dispatch(actions.fetchMonitoreoUserSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const postMonitoreoUser = (arg) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.postDataUserMonitoreo(arg);
        dispatch(actions.fetchMonitoreoUserAppError(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const resetLogin = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchResetLogin());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const resetDesgrabador = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchResetDesgrabador());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMenuUsuarios = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchMenuUsuarios();
        dispatch(actions.fetchMenuUsuariosSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getTrelloMonitoreo = (arg) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchTrelloMonitoreoRequestAction());
        const value = await api.fetchMonitoreoTrello(arg);
        dispatch(actions.fetchTrelloMonitoreoSuccessAction());
        return value;
      } catch (error) {
        dispatch(actions.fetchTrelloError(error));
      }
    };
  };
  
  export const fetchHomePedidos = (arg) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchFilterAppSuccessAction(arg));
  
        dispatch(actions.loadingAction());
        const data = await api.fetchHomePedidos(arg);
        dispatch(actions.fetchHomePedidosSuccessAction(data));
  
        dispatch(actions.loadingAction());
        const veredictos = await api.fetchVeredictos();
        dispatch(actions.fetchVeredictosSuccessAction(veredictos));
        dispatch(actions.
          fetchMenuAppSuccessAction({
            categories: [
              ["ME", "Mensajes", "/appministrador"],
              ["PE", "Pedidos", "/appministrador/pedidos"],
            ],
          })
        );
  
        dispatch(actions.loadingAction());
        const grafico = await api.getGrafico(arg);
        dispatch(actions.fetchGraficoSuccessAction(grafico));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const fetchMessagesPedidos = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchMessagesPedidos(id);
        dispatch(actions.fetchMessagesAppministradorPedidosSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const postMessages = (items, data3) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.postMessages(items);
        dispatch(actions.postResponseSuccessAction(data));
        const data1 = await api.fetchHomePedidos(data3);
        dispatch(actions.fetchHomePedidosSuccessAction(data1));
      } catch (error) {
        dispatch(actions.postResponseErrorAction());
      }
    };
  };
  
  export const getSimilares = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.getSimilares(id);
        dispatch(actions.fetchSimilaresSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMenuApp = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const menu = await api.getMenuApp();
        dispatch(actions.fetchMenuAppSuccessAction(menu));
      } catch (error) {
        dispatch(actions.fetchFilterError());
      }
    };
  };
  
  // NUEVO MONITREO funciones

    export const getMonitoreoAllEvents = () => {
    return async function (dispatch) {
      try {
        const items = await api.fetchDataMonitoreoEvents();
        dispatch(actions.monitoreoFetchAllEvents(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
    export const getMonitoreoAllTopics = () => {
    return async function (dispatch) {
      try {
        const items = await api.fetchDataMonitoreoTopics();
        dispatch(actions.monitoreoFetchAllTopics(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
    export const fetchCategoriasDetalle = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchCategoriasDetalle(id);
        dispatch(actions.fetchCategoriasDetalleSuccess(data));
      } catch (error) {
        dispatch(actions.showStatusRegistroManualError());
      }
    };
  };
  
    export const getMonitoreoByIDRequest = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoByID(id);
        dispatch(actions.fetchMonitoreoIDSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  /* const getMonitoreoCategoriasFormSelecTicket = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoCategoriasForm();
        dispatch(actions.fetchMonitoreoSuccessCategorias(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  }; */
  
    export const getMonitoreoPosts = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoCards();
        dispatch(actions.fetchCardsMonitoreoSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const getMonitoreoDesinformacionesDetalle = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoDesinformacionesDetalle(id);
        dispatch(actions.fetchDetalleDesinformacionesSuccess(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const getMonitoreoSearch = (query) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchSearchMonitoreoRequestAction());
        const data = await api.fetchDataMonitoreoSearch(query);
        dispatch(actions.fetchCardsMonitoreoSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const getMonitoreoSearchCategories = (query) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchDataMonitoreoSearchCategories(query);
        dispatch(actions.fetchMonitoreoSuccessCategorias(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const postMonitoreoAsociar = (asociar, id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.postMonitoreoAsociar(asociar, id);
        dispatch(actions.postMonitoreoAsociadoStatusSuccess());
        // TODO: getDataCard()
      } catch (error) {
        dispatch(actions.postMonitoreoAsociadoStatusFailure());
      }
    };
  };
  

export const postMonitoreoDesasociar = (asociar, id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        //const responseData = await api.fetchDataMonitoreoByID(id)
        const items = await api.postMonitoreoDesasociar(asociar, id);
        resetRegistroStatus();
      } catch (error) {
        dispatch(actions.postMonitoreoAsociadoStatusFailure());
      }
    };
  };
  

export const resetRegistroStatus = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.makeresetRegistroStatus());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  /* const getMonitoreoNuevaCategoria = (nuevaCategoria) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchMonitoreoNuevaCategoria(nuevaCategoria);
  
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoCategoriasForm();
        dispatch(actions.fetchMonitoreoSuccessCategorias(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
   */

export const postMonitoreoNuevoEvento = (nuevoEvento) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        // Create event
        const data = await api.postMonitoreoNuevoEvento(nuevoEvento);
        dispatch(actions.monitoreoNewEventAction(data));
  
        // Retrieve updated event list
        const items = await api.fetchDataMonitoreoEvents();
        dispatch(actions.monitoreoFetchAllEvents(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const fetchDesinformacionesID = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchDataMonitoreoTags(id);
        dispatch(actions.fetchMonitoreoSuccessDesinformacionesID(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const resetRegistroStatusManual = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.makeresetRegistroStatusManual());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  

export const getMonitoreoSearchBuscadorPpal = (query) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchSearchMonitoreoRequestAction());
        const data = await api.fetchDataMonitoreoSearchPpal(query);
        dispatch(actions.fetchMonitoreoSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const getRegistrosPage = (filtros) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.getRegistrosPage(filtros);
        dispatch(actions.fetchGuardadosPageSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  

export const getRelevancia = (relevance, id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchMonitoreoRequestAction());
        const items = await api.fetchgetRelevancia(relevance, id);
        /* dispatch(actions.getMonitoreoRequest({
          
          days: "",
          trending:"",
          registered:"",
          redes:"",
          ordering: "-relevance"
        }
          
        )) */
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const getNuevoId = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchMonitoreoNuevoIdSuccessAction(id));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getMonitoreoGuardadosSearch = (query) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const data = await api.fetchMonitoreoGuardadosSearch(query);
        dispatch(actions.fetchGuardadosPageSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const deleteRegistros = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.getdeleteRegistros(id);
        dispatch(
          
          getRegistrosPage({
            ordering: "",
            exported: "",
            status: "",
            tags: "",
          })
        );
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const getRegistroID = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fectchRegistroID(id));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const patchEditar = (editar, id) => {
    return async function (dispatch) {
      try {
        const items = await api.patchMonitoreoEditar(editar, id);
      } catch (error) {
        dispatch(actions.postMonitoreoAsociadoStatusFailure());
      }
    };
  };
  
  export const postTrello = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        await api.postCardTrello(id);
        dispatch(
          
          getRegistrosPage({
            ordering: "",
            exported: "",
            status: "",
            tags: "",
          })
        );
      } catch (error) {
        dispatch(actions.postMonitoreoAsociadoStatusFailure());
      }
    };
  };
  
  export const getRegistroIDdata = (params) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchgetRegistroIDdata(params);
        dispatch(actions.fetchGuardadosIDdataSuccessAction(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const changeView = () => {
    return async function (dispatch) {
      try {
        dispatch(actions.changeExpand());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
    export const getData = (arg) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchSendData(arg);
        if (data !== 200) {
          dispatch(actions.fetchDataSuccessAction("error"));
        } else {
          dispatch(actions.fetchDataSuccessAction("sucess"));
        }
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
    export const getUserDataCampanas = () => {
    return async function (dispatch) {
      try {
        const items = await api.fetchDataCampanas();
        dispatch(actions.fetchDataSuccessCampanas(items));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  export const getDesgrabadorHistorial = () => {
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabadorHistorial();
        dispatch(actions.fetchDesgrabadorHistorial(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
    export const getDesgrabadorHistorialID = (id, lang) => {
    console.log(id, lang);
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabadorHistorialID(id, lang);
        dispatch(actions.fetchDesgrabadorHistorialID(data));
  
        // Si el idioma es "es", filtra los textos y llama a getTextosDesgrabador
        if (lang === "es") {
          console.log("ESSSSS", lang);
          const textosEnEspañol = data.filter(
            (item) => item.language_code === "es"
          );
          const sentences = textosEnEspañol.map((el) => el.text);
          console.log("sentences", sentences && sentences.length > 0);
          if (sentences && sentences.length > 0) {
            await dispatch(getTextosDesgrabadorHistorial(sentences));
            console.log("getTextosDesgrabadorHistorial llamado con éxito.");
          } else {
            console.log("No hay sentences válidas para getTextosDesgrabador.");
          }
        }
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
    export const getDesgrabadorHistorialFicheroID = (id, lang) => {
    console.log(id, lang);
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabadorHistorialFicheroID(id, lang);
        dispatch(actions.fetchDesgrabadorHistorialFicheroID(data));
  
        if (lang === "es") {
          const textosEnEspañol = data.filter(
            (item) => item.language_code === "es"
          );
          console.log(textosEnEspañol);
          const sentences = textosEnEspañol.map((el) => el.text);
  
          if (sentences && sentences.length > 0) {
            await dispatch(getTextosDesgrabadorHistorial(sentences));
            console.log("getTextosDesgrabadorHistorial llamado con éxito.");
          } else {
            console.log("No hay sentences válidas para getTextosDesgrabador.");
          }
        }
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  
    export const getDesgrabadorHistorialFichero = () => {
    return async function (dispatch) {
      try {
        const data = await api.fetchDesgrabadorHistorialFichero();
        dispatch(actions.fetchDesgrabadorHistorialFichero(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  
    export const getVerificaciones = (params) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchVerificaciones(params);
        dispatch(actions.fetchVerificacionesSuccessAction(data));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
  
  
    export const getVerificacionesDelete = (id) => {
    return async function (dispatch) {
      try {
        const data = await api.getdeleteVerificaciones(id);
        dispatch(actions.fetchVerificaionesDelete(data));
  
        const reloadData = await api.fetchVerificaciones();
        dispatch(actions.fetchVerificacionesSuccessAction(reloadData));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  }
  
    export const getVerificaionesID = (id) => {
    return async function (dispatch) {
      try {
        dispatch(actions.loadingAction());
        const items = await api.fetchgetVerificacionesIDdata(id);
        dispatch(actions.fetchVerficacionesID(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  
    export const postVerificaionesNew = (name) => {
    return async function (dispatch) {
      try {
        const items = await api.postVerificacionNew(name);
        dispatch(actions.fetchVerficacionesNew(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  
  /* const putVerificaionesNueva = (id, items) => {
    return async function (dispatch) {
      try {
        const data = await api.putVerificaionesNueva(id, items);
        dispatch(actions.fetchVerficacionesNew(items));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  }; */
  
    export const putVerificaionesNueva = (id, items) => {
    return async function (dispatch) {
      try {
        // Estructurar los datos en el orden correcto
        const formattedData = {
          contentDescription: items.contentDescription || null,
          contentScreenshot: items.contentScreenshot || "",
          contentScreenshotWatermarked: items.contentScreenshotWatermarked || "",
          contentTypes: items.contentTypes || [],
          context: items.context || "",
          ratingId: items.ratingId || null,
          ratingJustification: items.ratingJustification || null,
          socialNetworks: items.socialNetworks || [],
          title: items.title || "",
          toolsUsed: items.toolsUsed || [],
          googleDocUrl: items.googleDocUrl || null,
        };
  
        // Primero actualiza el store con los datos actuales
        dispatch(actions.updateVerificacionInStore(formattedData));
  
        // Luego hace el PUT a la API
        const response = await api.putEditVerificacionId(id, formattedData);
  
        if (response) {
          // Si el PUT fue exitoso, actualiza el store con la respuesta
          dispatch(actions.updateVerificacion(response));
          return response;
        }
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
        throw error;
      }
    };
  };
  
  
  /* const putEditVerificacion = (id, items) => {
    return async function (dispatch) {
      try {
          const response = await api.putEditVerificacionId(id, items);
          console.log("Se está editando una verificación existente");
          dispatch(actions.fetchVerficacionesID(response.data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
   */
  
    export const putEditVerificacion = (id, items) => {
    return async function (dispatch) {
      try {
        // Estructurar los datos en el orden correcto
        const formattedData = {
          contentDescription: items.contentDescription || null,
          contentScreenshot: items.contentScreenshot || "",
          contentScreenshotWatermarked: items.contentScreenshotWatermarked || "",
          contentTypes: items.contentTypes || [],
          context: items.context || "",
          ratingId: items.ratingId || null,
          ratingJustification: items.ratingJustification || null,
          socialNetworks: items.socialNetworks || [],
          title: items.title || "",
          toolsUsed: items.toolsUsed || [],
          googleDocUrl: items.googleDocUrl || null,
        };
  
        // Primero actualiza el store con los datos actuales
        dispatch(actions.updateVerificacionInStore(formattedData));
  
        // Luego hace el PUT a la API
        const response = await api.putEditVerificacionId(id, formattedData);
  
        if (response) {
          // Si el PUT fue exitoso, actualiza el store con la respuesta
          dispatch(actions.updateVerificacion(response));
          return response;
        }
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
        throw error;
      }
    };
  };
  
    export const fetchVerficacionesRating = () => {
    return async function (dispatch) {
      try {
        const data = await api.fecthVerificaionesRating();
        dispatch(actions.fetchVerficacionesRatingData(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
  export const fetchVerficacionesBorrador = (id, formattedContent) => {
    return async function (dispatch) {
      try {
        const url = await api.fetchChequeadorBorrador(id, formattedContent);
  
        if (url) {
          window.open(url, "_blank");
        } else {
          console.error("La URL es nula o indefinida.");
          alert("No se ha recibido una URL válida.");
        }
  
        dispatch(actions.fetchBorrador(url));
      } catch (error) {
        if (error.response && error.response.status === 500 ) {
          // Aquí deberías mostrar tu modal
          dispatch(actions.showErrorModal());
        } else {
          console.error("Error inesperado:", error);
        }
      }
    };
  };
  

  
  
    export const fetchVerficacionesHtmlEditar = (id) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchHtmlChequeadorBorrador(id);
        dispatch(actions.fetchBorradorDataEditar(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
    export const fetchVerficacionesHtmlNuevo = (id) => {
    return async function (dispatch) {
      try {
        const data = await api.fetchHtmlChequeadorBorradorNuevo(id);
        dispatch(actions.fetchBorradorDataNuevo(data));
      } catch (error) {
        dispatch(actions.fetchMonitoreoError());
      }
    };
  };
  
    export const persistLegend = (value) => {
    return async function (dispatch) {
      try {
        dispatch(actions.setIsUploadingChequeador(value));
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };

  export const errorName = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.fetchResetNameCreate());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };


  export const showErrorModalClose = (status) => {
    return async function (dispatch) {
      try {
        dispatch(actions.showErrorModalClose());
      } catch (error) {
        dispatch(actions.fetchFailureAction(error));
      }
    };
  };
